import { render } from "./ProtectionsSection.vue?vue&type=template&id=7f92ffb6"
import script from "./ProtectionsSection.vue?vue&type=script&lang=js"
export * from "./ProtectionsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__